import { SignIn, SignUp } from "@clerk/react";

export default function AuthPage({ mode }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0a0a0c]" data-testid={`auth-page-${mode}`}>
      <div className="hidden lg:flex spotlight flex-col justify-end p-12 border-r border-[#2d2d38]">
        <span className="mono-label text-yellow-300">Online music camp</span>
        <h1 className="mt-3 text-5xl font-black tracking-tight">Eight rooms.<br />One stage each.</h1>
        <p className="mt-4 max-w-md text-zinc-400">Lessons, rehearsals and live shows, with a 12-channel mixer in every room.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        {mode === "in" ? (
          <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
        ) : (
          <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
        )}
      </div>
    </div>
  );
}
